<template>
	<section class="small-12 large-7 register flex justify-center animated fadeIn">
		<div class="small-12 large-7">
			<div class="small-12 socialSignUp">
				<h2 class="small-12 columns">Sign in to Nestd</h2>
				<ul class="small-12 columns flex vertical-align">
					<li>
						<p>Sign in with:</p>
					</li>
					<li>
						<google-auth-sign-in-button/>
					</li>
					<li>
						<p class="seperator">or</p>
					</li>
					<li>
						<apple-auth-sign-in-button/>
					</li>
					<li class="or small-12 flex justify-center">
						<hr class="small-12">
					</li>
				</ul>
			</div>
			<email-sign-in/>
		</div>
	</section>
</template>

<script>
	
	// Import the components
	import GoogleAuthSignInButton from '@/components/sisu/shared/GoogleAuthSignInButton.vue'
	import AppleAuthSignInButton from '@/components/sisu/shared/AppleAuthSignInButton.vue'
	import EmailSignIn from '@/components/sisu/shared/EmailSignIn.vue'

	export default {

		/*
		** Set the component name
		*/

		name: 'SignInForm',

		/*
		**  Register the components
		*/

		components: {

			EmailSignIn,
			GoogleAuthSignInButton,
			AppleAuthSignInButton

		}

	}

</script>